export default __webpack_public_path__ + "static/media/stickTime.ee5d02c9.png";